import React, { useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCyuWjyNiRGIGU5Iou5jjAvBoyCSTv2Ms8",
  authDomain: "numente-1014.firebaseapp.com",
  projectId: "numente-1014",
  storageBucket: "numente-1014.firebasestorage.app",
  messagingSenderId: "903524857362",
  appId: "1:903524857362:web:8d49139895c887c6e3cacb",
  measurementId: "G-X9VGJCPFFK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Only initialize messaging if in browser environment
let messaging = null;
if (typeof window !== 'undefined' && 'Notification' in window) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.error("Failed to initialize Firebase messaging:", error);
  }
}

const NotificationForm = () => {
  const [header, setHeader] = useState('');
  const [body, setBody] = useState('');
  const [fcmToken, setFcmToken] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  // Topic name
  const TOPIC = 'numente-general';

  // Get FCM token when component mounts
  useEffect(() => {
    if (typeof window !== 'undefined' && 'Notification' in window) {
      requestNotificationPermission();
    } else {
      setError('This browser does not support notifications');
    }
  }, []);

  const requestNotificationPermission = async () => {
    try {
      setIsLoading(true);
      setError('');
      
      // Check if notifications are supported
      if (!('Notification' in window)) {
        setError('This browser does not support notifications');
        return;
      }
      
      // Request permission (required for web)
      const permission = await Notification.requestPermission();
      console.log("🚀 ~ requestNotificationPermission ~ permission:", permission)
      
      if (permission === 'granted') {
        // Make sure messaging is available
        if (!messaging) {
          setError('Firebase messaging is not available');
          return;
        }
        
        const token = await getToken(messaging, { 
          vapidKey: 'BFDlyMJPZnJzQ6ug_pks-9lkfe_7WJ0xG-gMsZnP71ne9s2EEPrmcr1P8bIDkN7791nWDrKVWyNTwn53Mdlb58c'
        });
        
        if (token) {
          setFcmToken(token);
          console.log('FCM Token:', token);
          // Subscribe to topic
          subscribeToTopic(token);
        } else {
          setError('Failed to retrieve notification token');
        }
      } else {
        setError('Notification permission denied');
      }
    } catch (err) {
      console.error('Error getting notification permission:', err);
      setError('Failed to set up notifications: ' + err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const subscribeToTopic = async (token) => {
    try {
      setIsLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/notifications/subscribe-to-topic`, {
        token,
        topic: TOPIC,
      });
  
      if (response.status === 200) {
        setIsSubscribed(true);
      } else {
        setError('Failed to subscribe: ' + (response.data.error || 'Unknown error'));
      }
    } catch (err) {
      console.error('Error subscribing to topic:', err);
      setError('Failed to subscribe: ' + err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setIsLoading(true);
      setError('');
      setSuccess('');
      
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/notifications/send-notification`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          header,
          body,
          topic: TOPIC
        }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success('Notification sent successfully!');
        // Reset form
        setHeader('');
        setBody('');
      } else {
        setError('Failed to send notification: ' + (data.error || 'Unknown error'));
      }
    } catch (err) {
      console.error('Error sending notification:', err);
      setError('Failed to send notification: ' + err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-4 border rounded-lg shadow-md bg-white">
      <h2 className="text-xl font-semibold mb-4">Send Notification</h2>
      <ToastContainer />
      {/* Status messages */}
      {error && (
        <div className="mb-4 p-2 bg-red-100 text-red-700 rounded">
          {error}
        </div>
      )}
      
      {success && (
        <div className="mb-4 p-2 bg-green-100 text-green-700 rounded">
          {success}
        </div>
      )}
      
      {/* Subscription status */}
      <div className="mb-4 p-2 bg-gray-100 rounded flex justify-between items-center">
        <span>
          {isSubscribed 
            ? `✅ Subscribed to ${TOPIC}` 
            : `❌ Not subscribed to notifications`}
        </span>
        {/* {!isSubscribed && (
          <button 
            onClick={requestNotificationPermission}
            disabled={isLoading}
            className="bg-blue-600 text-white px-3 py-1 text-sm rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {isLoading ? 'Processing...' : 'Subscribe'}
          </button>
        )} */}
      </div>
      
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="d-block text-gray-700 mb-1">Title</label>
          <input
            type="text"
            value={header}
            onChange={(e) => setHeader(e.target.value)}
            className="w-full border px-3 py-2 rounded focus:outline-none focus:ring focus:border-blue-300"
            placeholder="Enter notification title"
            required
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              height: "50px",
              fontSize: "14px",
              width: "400px",
            }}
          />
        </div>
        <div className="mb-4">
          <label className="d-block text-gray-700 mb-1">Body</label>
          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            rows="5"
            className="w-full border px-3 py-2 rounded focus:outline-none focus:ring focus:border-blue-300"
            placeholder="Enter notification message"
            required
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              fontSize: "14px",
              width: "400px",
            }}
          ></textarea>
        </div>
        <button
          type="submit"
          disabled={isLoading || !isSubscribed}
          className="primaryBtn"
        >
          {isLoading ? 'Sending...' : 'Send Notification'}
        </button>
      </form>
    </div>
  );
};

export default NotificationForm;